import { Separator } from '~/components/ui'
import MapMinMaxFilter from './min-max'

type MapLeaseFilterProps = {
  minRate?: number
  maxRate?: number
  minSf?: number
  maxSf?: number
  updateFilter: (key: string, value: any) => void
}

export default function MapLeaseFilter({
  minRate,
  maxRate,
  minSf,
  maxSf,
  updateFilter,
}: MapLeaseFilterProps) {
  return (
    <div className="space-y-2">
      <Separator />
      <p className="font-semibold">Lease</p>
      <MapMinMaxFilter
        className="!mt-2"
        minName="min_rate"
        maxName="max_rate"
        label="Lease Rate"
        start="$"
        end="SF/yr"
        min={minRate}
        max={maxRate}
        updateFilter={updateFilter}
      />
      <MapMinMaxFilter
        minName="min_sf"
        maxName="max_sf"
        label="Available SF"
        end="SF"
        min={minSf}
        max={maxSf}
        updateFilter={updateFilter}
      />
    </div>
  )
}
